import { c as _c } from "react/compiler-runtime";
import useDocName from '../../hooks/use-doc-name';
import useIdDocMachine from '../../hooks/use-id-doc-machine';
import DesktopSelfieRetryView from './desktop-selfie-retry-view';
const DesktopSelfieRetry = () => {
  const $ = _c(11);
  const [state, dispatch] = useIdDocMachine();
  const {
    errors
  } = state.context;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      imageType: "selfie"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    getSideName
  } = useDocName(t0);
  let t1;
  if ($[1] !== getSideName) {
    t1 = getSideName();
    $[1] = getSideName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const sideName = t1;
  let t2;
  if ($[3] !== dispatch) {
    t2 = () => dispatch({
      type: "startImageCapture"
    });
    $[3] = dispatch;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleSelfieRetake = t2;
  let t3;
  if ($[5] !== errors) {
    t3 = errors ?? [{
      errorType: "unknown_error"
    }];
    $[5] = errors;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleSelfieRetake || $[8] !== sideName || $[9] !== t3) {
    t4 = <DesktopSelfieRetryView sideName={sideName} errors={t3} onSelfieRetake={handleSelfieRetake} />;
    $[7] = handleSelfieRetake;
    $[8] = sideName;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default DesktopSelfieRetry;